"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const surface_styles_1 = require("@/components/common/surface/surface.styles");
const disclosure_controller_1 = require("@/controllers/disclosure-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/indicators/expand-indicator/expand-indicator");
/**
 * 질문 하나와 접힌 답변. question이 트리거, 기본 슬롯이 펼쳐지는 답변입니다.
 * 트리거는 h4로 감싸 스크린리더가 제목 단위로 질문을 건너뛰게 한다(APG accordion).
 */
let FaqItem = class FaqItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.question = '';
        this.open = false;
        this.answerId = (0, utils_1.uniqueId)('faq-answer');
        this.disclosure = new disclosure_controller_1.DisclosureController(this, {
            isOpen: () => this.open,
            setOpen: open => {
                this.open = open;
            },
            getTrigger: () => this.trigger ?? undefined,
        });
    }
    render() {
        return (0, lit_1.html) `
      <h4>
        <button class="question" aria-controls=${this.answerId}>
          ${this.question}
          <mm-expand-indicator ?expanded=${this.open}></mm-expand-indicator>
        </button>
      </h4>

      <div id=${this.answerId} class="answer" ?inert=${!this.open}>
        <div><slot></slot></div>
      </div>
    `;
    }
};
FaqItem.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        --faq-item-padding: var(--space-2) var(--space-4);
        --faq-item-border: var(--border-transparent);
        --faq-item-border-radius: var(--radius);
        --faq-item-background-color: var(--background-subtle-color);

        ${surface_styles_1.surfaceBaseStyles};
        --surface-padding: var(--faq-item-padding);
        --surface-border: var(--faq-item-border);
        --surface-border-radius: var(--faq-item-border-radius);
        --surface-background-color: var(--faq-item-background-color);
      }

      .question {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--space-2);
        width: 100%;
      }

      /* auto 높이를 애니메이션하려고 0fr → 1fr 트랙을 쓴다 */
      .answer {
        display: grid;
        grid-template-rows: 0fr;
        overflow: hidden;
        transition: grid-template-rows var(--transition-duration) var(--transition-easing);
      }

      .answer > div {
        min-height: 0;
        transition: padding var(--transition-duration) var(--transition-easing);
      }

      :host([open]) {
        & .answer {
          grid-template-rows: 1fr;
        }
        & .answer > div {
          padding-top: var(--space-2);
          padding-bottom: var(--space-2);
        }
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], FaqItem.prototype, "question", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], FaqItem.prototype, "open", void 0);
__decorate([
    (0, decorators_js_1.query)('button.question')
], FaqItem.prototype, "trigger", void 0);
FaqItem = __decorate([
    (0, decorators_js_1.customElement)('mm-faq-item')
], FaqItem);
exports.FaqItem = FaqItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFxLWl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmYXEtaXRlbS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWtFO0FBRWxFLCtFQUE4RTtBQUM5RSwrRUFBMEU7QUFDMUUsK0RBQXlEO0FBQ3pELG1DQUFrQztBQUNsQyxxRUFBa0U7QUFFbEU7OztHQUdHO0FBRUksSUFBTSxPQUFPLEdBQWIsTUFBTSxPQUFRLFNBQVEsZ0JBQVU7SUFBaEM7O1FBaUR1QixhQUFRLEdBQUcsRUFBRSxDQUFBO1FBQ0csU0FBSSxHQUFHLEtBQUssQ0FBQTtRQUV2QyxhQUFRLEdBQUcsSUFBQSxnQkFBUSxFQUFDLFlBQVksQ0FBQyxDQUFBO1FBQzFDLGVBQVUsR0FBRyxJQUFJLDRDQUFvQixDQUFDLElBQUksRUFBRTtZQUNsRCxNQUFNLEVBQUUsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLElBQUk7WUFDdkIsT0FBTyxFQUFFLElBQUksQ0FBQyxFQUFFO2dCQUNkLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO1lBQ2xCLENBQUM7WUFDRCxVQUFVLEVBQUUsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLE9BQU8sSUFBSSxTQUFTO1NBQzVDLENBQUMsQ0FBQTtJQWdCSixDQUFDO0lBZEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O2lEQUVrQyxJQUFJLENBQUMsUUFBUTtZQUNsRCxJQUFJLENBQUMsUUFBUTsyQ0FDa0IsSUFBSSxDQUFDLElBQUk7Ozs7Z0JBSXBDLElBQUksQ0FBQyxRQUFRLDBCQUEwQixDQUFDLElBQUksQ0FBQyxJQUFJOzs7S0FHNUQsQ0FBQTtJQUNILENBQUM7O0FBekVNLGNBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7VUFPRyxrQ0FBaUI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7S0FxQ3RCO0NBQ0YsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7eUNBQWM7QUFDRztJQUEzQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztxQ0FBYTtBQUM5QjtJQUF6QixJQUFBLHFCQUFLLEVBQUMsaUJBQWlCLENBQUM7d0NBQThCO0FBbkQ1QyxPQUFPO0lBRG5CLElBQUEsNkJBQWEsRUFBQyxhQUFhLENBQUM7R0FDaEIsT0FBTyxDQTJFbkI7QUEzRVksMEJBQU8ifQ==